import { requestService } from '../helpers/request.service';

export const optionService = {
    getOption,
    getUploadOptions
};

function getOption(params) {
    return requestService.get({
        methodName: '/Option/GetOption',
        queryString: params
    });
}

function getUploadOptions() {
    let lastOption = sessionStorage.getItem('uploadOptions');
    if (lastOption) {
        try {
            return Promise.resolve(JSON.parse(lastOption));
        }
        catch {}
    }

    return requestService.get({
        methodName: '/Option/GetUploadOptions'
    }).then(response => {
        if (response) {
            sessionStorage.setItem('uploadOptions', JSON.stringify(response));
        }
        return response;
    });
}